import {
  Autocomplete,
  Box,
  Button,
  Chip,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import countries from "../../utils/countries";
import useGeneros from "../../hooks/useGeneros";
import {
  gestionaMultiplesArtistas,
  maxGeneros,
  normalizeGeneros,
} from "../../utils/tiposArtista";

export default function Step1({
  changeForm,
  mainData,
  setMainData,
  showSnack,
}) {
  const generos = useGeneros();
  const [inputValue, setInputValue] = useState("");

  const countryOptions = Object.entries(countries).map(([key, value]) => ({
    value: key,
    label: value,
  }));

  const generoOptions = generos.map((item) => ({
    value: item,
    label: item,
  }));

  // Los sellos, managers y labels representan a varios artistas, así que
  // cargan un catálogo de géneros en vez de uno solo (el tipo se eligió en
  // el paso 1, ya está disponible acá).
  const multiples = gestionaMultiplesArtistas(mainData?.tipo);
  const limite = maxGeneros(mainData?.tipo);
  const seleccionados = normalizeGeneros(mainData?.generos_musicales);

  const handleAdd = () => {
    if (!inputValue) {
      showSnack("No has ingresado ningún género válido!", "warning");
      return;
    }

    if (seleccionados.includes(inputValue)) {
      showSnack("Ya ingresaste este género!", "warning");
      return;
    }

    if (seleccionados.length >= limite) {
      showSnack(`Puedes registrar hasta ${limite} géneros.`, "warning");
      return;
    }

    setMainData((prev) => ({
      ...prev,
      generos_musicales: [
        ...normalizeGeneros(prev?.generos_musicales),
        inputValue,
      ],
    }));

    setInputValue("");
  };

  const handleDelete = (generoABorrar) => () => {
    setMainData((prev) => ({
      ...prev,
      generos_musicales: normalizeGeneros(prev?.generos_musicales).filter(
        (item) => item !== generoABorrar
      ),
    }));
  };

  return (
    <Stack alignItems="center">
      <Stack
        spacing={2.3}
        width={{ xs: "100%", sm: "90%", md: "70%", lg: "50%" }}
      >
        <Stack spacing={1}>
          <Stack direction="row" spacing={1} justifyContent="space-between">
            <Typography variant="p">
              Ingresa el país donde se ubica tu proyecto:
            </Typography>
            {mainData?.pais && (
              <img
                src={`https://flagcdn.com/${mainData.pais}.svg`}
                alt="País"
                width="30"
                height="20"
              />
            )}
          </Stack>

          <Autocomplete
            disablePortal
            disableClearable
            onChange={changeForm("pais")}
            options={countryOptions}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
          />
        </Stack>
        <Stack spacing={1}>
          <Typography variant="p">
            Ingresa una breve descripción de tu proyecto:
          </Typography>
          <TextField
            multiline
            rows={3}
            value={mainData?.descripcion || ""}
            onChange={changeForm("descripcion")}
            fullWidth
          ></TextField>
        </Stack>
        {multiples ? (
          <Stack spacing={1}>
            <Typography variant="p">
              Ingresa los géneros musicales que representas (hasta {limite}):
            </Typography>
            <Stack spacing={1} direction="row" alignItems="center">
              <Autocomplete
                disablePortal
                disableClearable
                onChange={(event, value, reason, details) =>
                  setInputValue(details.option.value)
                }
                options={generoOptions}
                fullWidth
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
              <Button onClick={handleAdd}>Agregar</Button>
            </Stack>
            <Stack direction="row" gap={1} marginTop={1} flexWrap="wrap">
              {seleccionados.map((item, i) => (
                <Chip key={i} label={item} onDelete={handleDelete(item)} />
              ))}
            </Stack>
          </Stack>
        ) : (
          <Stack spacing={1}>
            <Typography variant="p">
              Ingresa tu principal género músical:
            </Typography>
            <Autocomplete
              disablePortal
              disableClearable
              onChange={changeForm("generos_musicales")}
              options={generoOptions}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
